export let EstimateDistributionFeeScreen = /*#__PURE__*/function (EstimateDistributionFeeScreen) {
  EstimateDistributionFeeScreen[EstimateDistributionFeeScreen["products"] = 0] = "products";
  EstimateDistributionFeeScreen[EstimateDistributionFeeScreen["quantity"] = 1] = "quantity";
  EstimateDistributionFeeScreen[EstimateDistributionFeeScreen["enterZipCode"] = 2] = "enterZipCode";
  EstimateDistributionFeeScreen[EstimateDistributionFeeScreen["calculationProcess"] = 3] = "calculationProcess";
  EstimateDistributionFeeScreen[EstimateDistributionFeeScreen["uploadCSV"] = 4] = "uploadCSV";
  EstimateDistributionFeeScreen[EstimateDistributionFeeScreen["zipCodeResults"] = 5] = "zipCodeResults";
  return EstimateDistributionFeeScreen;
}({});